module.exports = __webpack_public_path__ + "img/shape12.73eb3f81.png";